<app-loader *ngIf="(loader | async)"></app-loader>